import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCloseCircleFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM9.87874 8.46443C9.48821 8.07391 8.85505 8.07391 8.46452 8.46443C8.10404 8.82492 8.07631 9.39215 8.38133 9.78443L8.46452 9.87864L10.5858 11.9999L8.46443 14.1213C8.07391 14.5118 8.07391 15.145 8.46443 15.5355C8.82492 15.896 9.39215 15.9237 9.78443 15.6187L9.87864 15.5355L12 13.4141L14.1214 15.5355C14.5119 15.926 15.1451 15.926 15.5356 15.5355C15.8961 15.175 15.9238 14.6078 15.6188 14.2155L15.5356 14.1213L13.4142 11.9999L15.5355 9.87862C15.926 9.4881 15.926 8.85493 15.5355 8.46441C15.175 8.10392 14.6078 8.07619 14.2155 8.38122L14.1213 8.46441L12 10.5857L9.87874 8.46443Z" })
});
export default SvgCloseCircleFill;
